import { render, staticRenderFns } from "./VAppLoader.vue?vue&type=template&id=e4802354&scoped=true&"
import script from "./VAppLoader.vue?vue&type=script&lang=js&"
export * from "./VAppLoader.vue?vue&type=script&lang=js&"
import style0 from "./VAppLoader.vue?vue&type=style&index=0&id=e4802354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4802354",
  null
  
)

export default component.exports